export const SAVE_APPLY_INSURANCE_FORM = 'SAVE_APPLY_INSURANCE_FORM';
